import React, { useEffect, useState, useCallback } from "react";
import PurpleRing from "../../assests/images/purple-ring-form.svg";
import rightArrow from "../../assests/images/btn-right-arrow.png";
import lockImg from "../../assests/images/form-lock.png";
import checkImg from "../../assests/images/greenCheck.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import renderStarImages from "../../hooks/RenderStar";
import { FormRevData } from "../../utils/FormData";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import arrowImg from "../../assests/images/progressbar-arrow.png";
import rightImg from "../../assests/images/progressbar-right.png";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const Que1 = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isIndia = urlParams.has("country-in");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const [responses, setResponses] = useState({});
  const [clicked, setClicked] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [formValue, setFormValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [countryCode, setCountryCode] = useState("");
  const [getOtp, setGetOtp] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpButtonText, setOtpButtonText] = useState("SUBMIT");
  const [canResend, setCanResend] = useState(true);
  const [resendText, setResendText] = useState(
    "Didn't Received an OTP? Resend OTP"
  );
  const [verifyButtonText, setVerifyButtonText] = useState("SUBMIT");
  const [disableVerify, setDisableVerify] = useState(false);
  const [counter, setCounter] = useState(0);
  const handleOtpChange = (e) => {
    const value = e.target.value;

    // Allow only numbers and limit to 4 characters
    if (/^\d{0,4}$/.test(value)) {
      setOtpValue(value);
    }
  };
  const [checkBox, setCheckBox] = useState(true);
  const handleCheckBox = () => {
    setCheckBox((prevState) => !prevState);
  };
  const FormData = [
    {
      id: 1,
      question: "",
    },
    {
      id: 2,
      question: "Which best describes the issue at the property?",
      description2: "Select all that apply below.",
    },
    {},
    {
      id: 4,
      question: `OK ${formValue?.firstName}, please enter your (valid) contact number below so we can get in contact`,

    },
  ];

  const handleSelection = (text) => {
    if (text === "Other") {
      setSelectedItems(selectedItems.includes("Other") ? [] : ["Other"]);
    } else {
      setSelectedItems((prevSelected) =>
        prevSelected.includes(text)
          ? prevSelected.filter((item) => item !== text)
          : [...prevSelected.filter((item) => item !== "Other"), text]
      );
    }
  };

  const getButtonStyle = (value) => ({
    backgroundColor: clicked === value ? "#02BA76" : "",
    border: clicked === value ? "none" : "",
    color: clicked === value ? "white" : "",
  });

  const defaultStyle = {
    background: "linear-gradient(270deg, #08A972 0%, #1B75BB 100%)",
    color: "white",
  };
  const navigate = useNavigate();
  const numbers = [2, 3, 4, 5];
  const data = FormData;
  const revData = FormRevData;
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    question,
    description1,
    description2,
    id: dataID,
  } = data[currentIndex];
  const { id: revID, userImage, desc, userName } = revData[currentIndex] || {};

  const mergedObject = [{ ...formValue }];
  const hasNumbers = /\d/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [phoneNumberFlag, setPhoneNumberFlag] = useState("US");

  // const loadIntlTelInput = async () => {
  //   const phoneInput = document.querySelector("#phone-input");
  //   if (!phoneInput) return;

  //   const iti = window.intlTelInput(phoneInput, {
  //     initialCountry: "gb",
  //     onlyCountries: ["gb"],
  //     utilsScript:
  //       "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js",
  //   });

  //   // Set initial country code right after initializing the input
  //   const selectedCountry = iti.getSelectedCountryData();
  //   setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
  //   setCountryCode(selectedCountry?.dialCode);

  //   phoneInput.addEventListener("countrychange", function () {
  //     const selectedCountry = iti.getSelectedCountryData();
  //     setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
  //     setCountryCode(selectedCountry?.dialCode);
  //   });
  // };

  // useEffect(() => {
  //   if (currentIndex === 3) {
  //     loadIntlTelInput();
  //   }
  // }, [currentIndex]);
  const loadIntlTelInput = useCallback(async () => {
    const phoneInput = document.querySelector("#phone-input");
    if (!phoneInput) return;

    const iti = window.intlTelInput(phoneInput, {
      initialCountry: isIndia ? "in" : "gb",
      onlyCountries: ["in", "gb"], // You can add more countries if needed
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js",
    });

    // Set initial country code right after initializing the input
    const selectedCountry = iti.getSelectedCountryData();
    setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
    setCountryCode(selectedCountry?.dialCode);

    phoneInput.addEventListener("countrychange", function () {
      const selectedCountry = iti.getSelectedCountryData();
      setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
      setCountryCode(selectedCountry?.dialCode);
    });
  }, [isIndia]);
  useEffect(() => {
    if (currentIndex === 3) {
      loadIntlTelInput();
    }
  }, [currentIndex, loadIntlTelInput]);

  const [ipv4Address, setIpv4Address] = useState("");
  const [ipv6Address, setIpv6Address] = useState("");
  useEffect(() => {
    const getIpAddress = async () => {
      try {
        const response = await fetch('/.netlify/functions/getIp');
        const data = await response.json();

       
        setIpv4Address(data.ipv4 || 'Unknown IPv4');
        setIpv6Address(data.ipv6 || 'Unknown IPv6');
      } catch (error) {
        console.error('Error fetching IP:', error);
      }
    };

    getIpAddress();
  }, []);

  const questionOne = "Who do you rent from?";
  const questionTwo =
    "Have you reported this damage to your council or housing association and remains unresolved for more than 4 months?";
  const questionThree = "Which best describes the issue at the property?";
  const handleSubmit = async () => {
    try {
      const localData = localStorage?.getItem("FormValues");
      const dataObject = localData ? JSON.parse(localData)[0] : {};

      const selectionData = localStorage?.getItem("selectedChoices");
      const selectedParse = selectionData ? JSON.parse(selectionData) : [];

      const { firstName, lastName, email, phone } = dataObject;

      let utmParams = {};
      const storedUTMParams = localStorage.getItem("utmParams");

      if (storedUTMParams) {
        const utmParamsArray = JSON.parse(storedUTMParams);
        utmParamsArray.forEach((param) => {
          const key = Object.keys(param)[0];
          utmParams[key] = param[key];
        });
      }
      const jsonData = {
        [questionOne]: localStorage?.getItem("selectedButtonText"),
        [questionTwo]: responses[1],
        [questionThree]: selectedParse,
        firstName: firstName,
        lastName: lastName,
        email: email,
        ipv4: ipv4Address,
        ipv6: ipv6Address,
        phone: `+${countryCode}${phone}`,
        dateSubmittedOn: formattedDate,
        acceptedPrivacyPolicy: !checkBox ? "yes" : "no",

        ...utmParams,
      };
      fetch("/.netlify/functions/proxyZapier", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
      })
        .then((response) => response.json())
        .then((result) => {
          window.location.replace("/form/success");
        })
        .catch((error) => {
          toast.error(error.message || "An error occured.");
        });
    } catch (error) {
      toast.error(error.message || "An error occured.");
    }
  };
  const handleContinue = () => {
    let thirdIndexCondition =
      hasNumbers.test(formValue?.firstName) ||
      hasNumbers.test(formValue?.lastName) ||
      formValue?.firstName === "" ||
      formValue?.lastName === "";
    let fourthIndexCondition =
      formValue?.email === "" || !emailPattern.test(formValue?.email);

    if (currentIndex < data?.length - 1) {
      if (currentIndex === 0) {
        if (clicked === "no") {
          navigate("/form/sorry");
        } else if (clicked === null) {
          toast.error("No selection made. Please provide valid input.");
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      }

      if (currentIndex === 2) {
        if (thirdIndexCondition || fourthIndexCondition) {
          toast.error("Please enter valid details.");
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      }
    }

    if (currentIndex === 1) {
      if (selectedItems.length !== 0) {
        localStorage.setItem("selectedChoices", JSON.stringify(selectedItems));
        setCurrentIndex(currentIndex + 1);
      } else {
        toast.warn("Please select at least one option");
      }
    }
    if (currentIndex === 3) {
      const phoneNumber = parsePhoneNumberFromString(
        formValue?.phone,
        phoneNumberFlag
      );
      if (!phoneNumber || !phoneNumber.isValid()) {
        toast.error("Please enter a valid phone number");
      } else {
        localStorage.setItem("FormValues", JSON.stringify(mergedObject));
      }
    }
  };

  //re-com

  const canAttemptOTP = (phoneNumber) => {
    const maxAttempts = 5;
    const resetTime = 15 * 60 * 1000;
    const attemptDataKey = `otp_attempts_${phoneNumber}`;

    const attemptData = JSON.parse(localStorage.getItem(attemptDataKey)) || {
      attempts: 0,
      lastAttemptTime: null,
    };

    const now = Date.now();

    if (
      attemptData.lastAttemptTime &&
      now - attemptData.lastAttemptTime > resetTime
    ) {
      attemptData.attempts = 0;
      attemptData.lastAttemptTime = now;
    }

    if (attemptData.attempts >= maxAttempts) {
      return {
        allowed: false,
        message: "Maximum OTP attempts reached. Try again later.",
      };
    }

    attemptData.attempts += 1;
    attemptData.lastAttemptTime = now;

    localStorage.setItem(attemptDataKey, JSON.stringify(attemptData));

    return { allowed: true };
  };

  const sendOtp = async () => {
    setOtpButtonText("Sending OTP...");
    // Get the phone number and phone number flag from the state
    localStorage.setItem("FormValues", JSON.stringify(mergedObject));
    const localData = localStorage?.getItem("FormValues");
    const [dataObject] = JSON.parse(localData);
    const { phone } = dataObject;

    //making a variable with countryCode for twilio verification
    const fullNumber = `+${countryCode}${phone}`;
      const phoneNumber = parsePhoneNumberFromString(
      formValue?.phone,
      phoneNumberFlag
    );

    if (!phoneNumber || !phoneNumber?.isValid()) {
      toast.error("Please enter a valid phone number");
      setOtpButtonText("SUBMIT");

      return { ok: false }; // Return a response-like object for error cases
    }

    // Check if the user can attempt to request an OTP
    const result = canAttemptOTP(formValue.phone);
    if(!checkBox === true) {
      if (!result.allowed) {
        toast.error(result.message);
        return { ok: false }; // Return a response-like object for error cases
      }
      try {
        const response = await fetch("/.netlify/functions/send-otp", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumber: fullNumber, // Send the correct field name
          }),
        });
  
        if (response.ok) {
          setGetOtp(true);
          toast.success("Message Sent Successfully", { toastId: 1 });
        } else {
          setGetOtp(false);
          setOtpButtonText("SUBMIT");
          const errorData = await response.json();
          console.error("Error sending message:", errorData.error);
          toast.error(errorData.error || "An error occurred", { toastId: 2 });
        }
      } catch (error) {
        toast.error(error.message || "An error occurred", { toastId: 2 });
        console.error("Network error:", error);
      } finally {
        setOtpButtonText("SUBMIT");
      }
    }
    else {
      setOtpButtonText("SUBMIT");
      toast.warn("Please accept the privacy policy");
    }
  };

  const verifyOtp = async () => {
    try {
      setDisableVerify(true);
      setVerifyButtonText("Verifying...");
      localStorage.setItem("FormValues", JSON.stringify(mergedObject));
      const localData = localStorage?.getItem("FormValues");
      const [dataObject] = JSON.parse(localData);
      const { phone } = dataObject;

      //making a variable with countryCode for twilio verification
      const fullNumber = `+${countryCode}${phone}`;
      const response = await fetch("/.netlify/functions/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber: fullNumber, otp: otpValue }),
      });
      if (response.ok) {
        toast.success("OTP verified successfully!", { toastId: 1 });
        setIsVerified(true);
        handleSubmit();
      } else {
        setDisableVerify(false);
        toast.error("An error occured, Try again.", {
          toastId: 2,
        });
        setVerifyButtonText("SUBMIT");
      }
    } catch (error) {
      setDisableVerify(false);
      toast.error(error.message || "An error occured, Try again.", {
        toastId: 2,
      });
    }
  };

  const resendOtp = async () => {
    if (!canResend) {
      toast.warn(`Please wait ${counter} seconds before resending OTP.`, {
        toastId: 1,
      });
      return;
    }

    setDisableVerify(false);
    const phoneNumber = parsePhoneNumberFromString(
      formValue?.phone,
      phoneNumberFlag
    );

    if (!phoneNumber || !phoneNumber?.isValid()) {
      toast.error("Please enter a valid phone number");
      return;
    }

    try {
      //fire the sendOtp function again , for resending the otp
      const response = await sendOtp(); // Await the `sendOtp` function
      if (response?.ok) {
        // Check if the response indicates success
        setOtpValue("");
        setCanResend(false);
        setResendText(`OTP Sent, Please wait...`);
        setCounter(30);

        const interval = setInterval(() => {
          setCounter((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              setCanResend(true);
              setResendText("Didn't Receive OTP? Resend OTP");
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        // toast.error("Failed to resend OTP. Please try again.", { toastId: 3 });
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP. Please try again.");
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue(() => ({
      ...formValue,
      [name]: value,
    }));
  };
  const handleClick = (value) => {
    setResponses((prev) => ({
      ...prev,
      [data[currentIndex]?.id]: value,
    }));
  };
  useEffect(() => {
    if (clicked) {
      const timer = setTimeout(() => {
        if (currentIndex === 0 && Object.values(responses)[0] === "yes") {
          setCurrentIndex((prevIndex) => prevIndex + 1);
          setClicked("");
        } else {
          navigate("/form/sorry");
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [clicked, currentIndex, responses, navigate]);
  return (
    <>
      <div className="form-progressBar">
        <div className="number" style={defaultStyle}>
          <img src={rightImg} alt="arrow" />
        </div>
        <img className="arrow" src={arrowImg} alt="arrow" />
        {numbers?.map((num, index) => (
          <React.Fragment key={index}>
            <div
              className="number"
              style={currentIndex >= index ? defaultStyle : {}}
            >
              {currentIndex <= index ? num : <img src={rightImg} alt="" />}
            </div>
            {index < numbers.length - 1 && (
              <img className="arrow" src={arrowImg} alt="arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="form-que1 " key={dataID}>
        <img src={PurpleRing} alt="" className="ring" />
        <h3>{question}</h3>
        <p>
          {description1}
          <span>{description2}</span>
        </p>

        {currentIndex === 0 && (
          <div>
            <div className="question">
              <h3>
                Have you reported this damage to your council or housing
                association and remains unresolved for more than 4 months?
              </h3>
              <div className="ansBtn">
                <button
                  className="btn"
                  value="yes"
                  style={getButtonStyle("yes")}
                  onClick={(e) => {
                    handleClick("yes");
                    setClicked("yes");
                  }}
                >
                  Yes
                </button>
                <button
                  value="no"
                  className="btn"
                  style={getButtonStyle("no")}
                  onClick={(e) => {
                    handleClick("no");
                    setClicked("no");
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        {currentIndex === 2 && (
          <div>
            <h3 className="question two">
            Good news, you could qualify for a free claim assessment, Just 2 more steps to go:
            </h3>
            <div className="fullName">
              <div className="column fullName-col">
                <label>First Name</label>
                <input
                  type="text"
                  placeholder="Alex"
                  name="firstName"
                  id="firstName"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </div>
              <div className="column fullName-col">
                <label>Last Name</label>
                <input
                  type="text"
                  placeholder="Smith"
                  name="lastName"
                  id="lastName"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </div>
            </div>
            <div className="email">
              <div className="column">
                <label>Enter your email address</label>
                <input
                  type="text"
                  name="email"
                  placeholder="Email..."
                  id="email"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div className="button-grid">
          {currentIndex === 1 &&
            [
              "Mould & Damp",
              "Leak Or Water Damage",
              "Window Faults",
              "Boiler Or Heating",
              "Drainage Issues",
              "Electrical Issues",
              "Guttering Issues",
              "Pest Infestation",
              "Structural Issues",
              "Other",
            ].map((text, index) => (
              <div className="" key={index}>
                <button
                  onClick={() => handleSelection(text)}
                  className={selectedItems.includes(text) ? "selected" : ""}
                >
                  {text}
                </button>
              </div>
            ))}
        </div>
        {currentIndex === 3 && (
          <div className="phoneNumber">
            <div className="column">
              <label>Telephone Number *</label>
              <input
                id="phone-input"
                type="tel"
                name="phone"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          </div>
        )}
        {currentIndex !== 0 &&
          currentIndex !== 1 &&
          currentIndex !== 2 &&
          getOtp === false && (
            <div className={`continueBtn`}>
              <button
                className={`${getOtp ? "disable" : ""}`}
                onClick={() => {
                  sendOtp();
                }}
              >
                {otpButtonText}
              </button>
            </div>
          )}
        {getOtp === true && (
          <div>
            <div className="phoneNumber">
              <div className="column">
                <label>OTP *</label>
                <input
                  id="otp-input"
                  type="number"
                  name="otp"
                  placeholder="Enter 4 Digit OTP"
                  max={9}
                  maxLength={4}
                  onChange={(e) => {
                    handleOtpChange(e);
                  }}
                  value={otpValue}
                />
                <div className="resend">
                  <div>
                    <button
                      className="resend-otp"
                      onClick={() => {
                        resendOtp();
                      }}
                    >
                      <span className="underline">
                        {counter > 0
                          ? `Resend OTP in ${counter} seconds`
                          : resendText}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="verifyOtpButton">
              {currentIndex === FormData.length - 1 && !isVerified && (
                <div className="continueBtn">
                  <button
                    className={`${disableVerify ? "disableClass" : ""}`}
                    disabled={disableVerify}
                    onClick={() => {
                      verifyOtp();
                    }}
                  >
                    {verifyButtonText}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {isVerified && (
          <div className="continueBtn">
            <button type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        )}
        {currentIndex !== 0 && currentIndex !== FormData.length - 1 && (
          <div className="continueBtn">
            <button type="button" onClick={handleContinue}>
              {currentIndex === FormData.length - 1 ? "Submit" : "Continue"}
              <span>
                <LazyLoadImage className="arrow" src={rightArrow} alt="arrow" />
              </span>
            </button>
          </div>
        )}
        <div className="lockInfo">
          {currentIndex !== FormData.length - 1 ? (
            <div>
                   <img src={lockImg} alt="lock" />
<p>Your Information is safe & secure</p>  
            </div>
          ) : (
            <div>
                <input
                type="checkbox"
                checked={!checkBox}
                id="last-check"
                onChange={handleCheckBox}
              />

              <label htmlFor="last-check">
                By clicking 'submit', I consent for the Claim Solutions Scotland
                to process the submitted personal data, including health data,
                to contact me in relation to a potential claim{" "}
                <a
                  href="https://www.claim-solutions-scotland.co.uk/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  privacy policy.
                </a>
              </label>
            </div>
          )}
        </div>
      </div>
      {revID !== undefined && (
        <div className="form-rev">
          <div className="container">
            <div className="review-image">
              <LazyLoadImage src={userImage} alt="user" />
            </div>
            <div className="review-details">
              {renderStarImages(5)}
              <p dangerouslySetInnerHTML={{ __html: desc }}></p>
              <span className="user">
                <span className="userName">{userName}</span>
                <div className="verified">
                  <LazyLoadImage className="check" src={checkImg} alt="check" />
                  <span>Verified customer</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Que1;
